export class EnumToUiOption {
    cssClass = '';
    label = '-';
    order? = 0;
    image? = '';
    description? = '';
}
